import TableSortLabel from '@mui/material/TableSortLabel';
import Typography from '@mui/material/Typography';
import styled from 'styled-components/macro';

import Select from 'components/Select/Select';

export const SortableColumnLabelStyled = styled(TableSortLabel)`
  max-width: 100%;
  width: 100%;

  .MuiTableSortLabel-icon {
    flex-shrink: 0;
  }
`;

export const SortableColumnTextStyled = styled(Typography)`
  min-width: 0;
`;

export const SelectStyled = styled(Select)`
  width: 50%;
  margin-right: 10px;
  font-size: 0.875rem;
`;
